import React from 'react';
import { Link } from 'react-router-dom';

const IconSearch = () => (
  <svg className="feature-icon-svg" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M10.5 18a7.5 7.5 0 100-15 7.5 7.5 0 000 15zM16.5 16.5L21 21"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconList = () => (
  <svg className="feature-icon-svg" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M4 6h16M4 12h16M4 18h10"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconShield = () => (
  <svg className="feature-icon-svg" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path
      d="M12 3l7 3v6c0 5-3.5 9-7 10-3.5-1-7-5-7-10V6l7-3z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

const Home = () => {
  return (
    <div className="page home">
      <header className="hero">
        <div className="hero-glow" aria-hidden />
        <div className="hero-inner">
          <p className="hero-eyebrow">Marketplace · Inspire The Next Inc.</p>
          <h1 className="hero-title">
            Buy and sell cars with <span className="hero-title-accent">confidence</span>
          </h1>
          <p className="hero-lede">
            CarEx Marketplace is the online platform from <strong>Inspire The Next Inc.</strong>{' '}
            for secure vehicle listings—browse inventory, list your car, and use trusted
            payment options where available.
          </p>
          <div className="app-badges">
            <a
              href="https://apps.apple.com/us/app/carex-marketplace/id6758438618"
              className="download-btn download-btn--primary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="download-btn-icon" aria-hidden>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                </svg>
              </span>
              App Store
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.carex.market"
              className="download-btn download-btn--secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="download-btn-icon" aria-hidden>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 010-1.22l7.203-8.407-7.202-8.555a.996.996 0 011.22-1.185zm1.21 20.556L14.622 12 4.82 1.838a.998.998 0 011.405-1.404l11.954 6.924c.66.38.66 1.313 0 1.694L6.226 21.57a1.002 1.002 0 01-1.405-1.2zM16.803 8.09l2.168-1.268c.5-.293.813.153.496.552l-2.255 3.143 2.262 3.143c.317.399.005.845-.496.552l-2.168-1.268V8.09z" />
                </svg>
              </span>
              Google Play
            </a>
          </div>
        </div>
      </header>

      <section className="features" aria-label="What you can do">
        <article className="feature-card">
          <div className="feature-icon" aria-hidden>
            <IconSearch />
          </div>
          <h2 className="feature-title">Buy cars</h2>
          <p className="feature-desc">Browse thousands of listings from trusted sellers.</p>
        </article>
        <article className="feature-card">
          <div className="feature-icon" aria-hidden>
            <IconList />
          </div>
          <h2 className="feature-title">Sell your car</h2>
          <p className="feature-desc">
            Publish a listing in minutes and reach buyers when they search.
          </p>
        </article>
        <article className="feature-card">
          <div className="feature-icon" aria-hidden>
            <IconShield />
          </div>
          <h2 className="feature-title">Secure payments</h2>
          <p className="feature-desc">Pay and get paid with safeguards designed for peace of mind.</p>
        </article>
      </section>

      <section className="home-about">
        <div className="home-about-inner">
          <h2 className="home-about-heading">About our business</h2>
          <p>
            <strong>CarEx Marketplace</strong> is operated by <strong>Inspire The Next Inc.</strong>{' '}
            We provide a digital platform that connects buyers and sellers of motor vehicles,
            along with account tools and optional paid services as described in our app and on
            this site.
          </p>
          <p className="home-about-links">
            For customer support, refunds, returns, and other buyer and seller policies, see{' '}
            <Link to="/support">Support</Link> and{' '}
            <Link to="/marketplace-policies">Marketplace policies</Link>.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Home;
